import { TextField as MuiTextField, Popper, autocompleteClasses } from '@mui/material';
import { Divider } from '../Divider';
import { FormControlLabel } from '../FormControl';
import { Paper } from '../Paper';
import { outlinedInputClasses } from '../TextField';
import { styled } from '../muiReexports';
export const PopperStyled = styled(Popper)(({ width }) => ({
    width: width ?? '100%',
}));
export const FilterTextField = styled(MuiTextField)(({ theme }) => ({
    paddingInline: theme.spacing(2),
    [`.${outlinedInputClasses.root}`]: {
        padding: '0 .5rem !important',
    },
}));
export const PaperStyled = styled(Paper)(({ theme }) => ({
    boxShadow: theme.shadows[11],
    borderRadius: `var(--gp-radius-xl)`,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.zinc[800],
    }),
}));
export const PaperHead = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(2),
    backgroundColor: 'transparent',
}));
export const FormControlLabelStyled = styled(FormControlLabel)(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2, 3),
    marginLeft: 0,
}));
export const StyledDivider = styled(Divider)(({ theme }) => ({
    marginTop: 0,
    marginBottom: theme.spacing(1),
    marginInline: theme.spacing(-1.25),
}));
// TODO: to delete all unnecessary comments
export const AutocompletePopperStyled = styled('div')(({ theme }) => ({
    boxShadow: 'none',
    borderRadius: 0,
    [`& .${autocompleteClasses.paper}`]: {
        boxShadow: 'none',
        margin: 0,
        color: 'inherit',
        //fontSize: 13,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: `var(--gp-radius-lg)`,
        borderBottomRightRadius: `var(--gp-radius-lg)`,
    },
    [`& .${autocompleteClasses.listbox}`]: {
        padding: theme.spacing(1, 0),
        [`.${autocompleteClasses.option}`]: {
            position: 'relative',
            paddingRight: theme.spacing(9),
            marginRight: theme.spacing(2),
            gap: theme.spacing(2),
        },
    },
}));
